import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import ShowMeButton from '../components/ShowMeButton.tsx';
import { CREATE_IDEAS_TOUR_STEP_1_SPOTLIGHT_ID } from '../ui/spotlights/create-ideas/constants.tsx';
import { useActions } from '../services/index.tsx';
import TaskDescriptionRoleRestrictions from '../components/TaskDescriptionRoleRestrictions.tsx';
import { messages } from './createIdeas.messages.tsx';
import { TASK_CREATE_IDEAS } from './constants.tsx';
import type { TaskDefinition } from './types.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	const { setSpotlightStepId } = useActions();
	return (
		<TaskDescription>
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<TaskDescriptionRoleRestrictions description={formatMessage(messages.roleRestrictionsText)} />
			<ShowMeButton onClick={() => setSpotlightStepId(CREATE_IDEAS_TOUR_STEP_1_SPOTLIGHT_ID)} />
		</TaskDescription>
	);
};

export const createIdeas = {
	id: TASK_CREATE_IDEAS,
	title: messages.title,
	description: <Description />,
} satisfies TaskDefinition;
